import React from 'react';
import { Link } from 'react-router-dom';
import { UserShape, TackShape, NavigationShape, WordShape } from '../shapes';
import Waiting from './waiting';
import RecommendedWords from './recommended_words';
import PropTypes from 'prop-types';
import WordHeader from './word/header';

export default class TackConfirmation extends React.Component {
  static propTypes = {
    user: UserShape,
    tack: TackShape,
    word: WordShape,
    params: PropTypes.object,
    navigation: NavigationShape
  }

  render() {
    return (
      <div className='word'>
        <WordHeader wordText={this.props.params.wordText} pronunciationFile={this.props.word.get('pronunciationFile')} partOfSpeech={this.props.word.get('partOfSpeech')} mnemonicImageUrl={this.props.word.get('mnemonicImageUrl')} />
        { this.renderBody() }
      </div>
    );
  }

  renderBody() {
    if (this.props.tack.get('tackError')) {
      return this.renderTackError();
    } else if (this.props.tack.get('loading')) {
      return this.renderWaiting();
    } else if (this.props.user.get('queuedTacksCount') > 0) {
      return this.renderConfirmationWithTackQueue();
    } else {
      return this.renderConfirmation();
    }
  }

  renderConfirmationWithTackQueue() {
    return (
      <div className='row tack-queue-confirmation'>
        <div className='col-sm-12'>
          <p>
            "{ this.props.params.wordText }" has been added to your queue and is number { this.props.user.get('queuedTacksCount') } in line.
          </p>
          <p>
            You're on the Free for One plan which means <b>we'll hold off tacking "{this.props.params.wordText}"</b> since we're already helping you
            remember another word.
          </p>
          <p>
            You can always go Unlimited to start tacking this word now.
          </p>
          { <RecommendedWords wordText={ this.props.params.wordText } recommendedWords={ this.props.tack.get('recommendedWords') } /> }
          <div className='action'>
            <Link to='/plans' className='btn btn-outline-secondary'>Go Unlimited</Link>
            <Link to={ this.thanksLink() } className='btn btn-dark' data-primary-cta='true'>Thanks</Link>
          </div>
        </div>
      </div>
    );
  }

  renderWaiting() {
    return(
      <Waiting />
    )
  }

  renderConfirmation() {
    return (
      <div className='row'>
        <div className='col-sm-12'>
          Done! You've started tacking the word <b>{ this.props.params.wordText }</b>. We'll send your first notification tomorrow.
          { <RecommendedWords wordText={ this.props.params.wordText } recommendedWords={ this.props.tack.get('recommendedWords') } /> }
        </div>
        <div className='col-sm-12 action'>
          <Link to={ this.thanksLink() } className='btn btn-dark' data-primary-cta='true'>Thanks</Link>
        </div>
      </div>
    );
  }

  renderTackError() {
    return(
      <div className='row tack-confirmation'>
        <div className='error col-sm-12' >
          { `Hmm. ${ this.props.tack.get('tackError') }.` }
        </div>
        <div className='col-sm-12 action'>
          <Link to={ this.thanksLink() } className='btn btn-dark' data-primary-cta='true'>Got It</Link>
        </div>
      </div>
    )
  }

  thanksLink() {
    return this.props.navigation.get('afterTackPathname') || '/';
  }
}



// WEBPACK FOOTER //
// ./src/components/tack_confirmation.jsx